/* =============================================================
   FG — Speciale editore

   Due cose sole, e nessuna delle due ricarica la pagina:
     1. i chip filtrano e ordinano quello che e' gia' stampato
     2. il Tavolo legge il carrello VERO e, quando manca poco alla
        spedizione gratis, propone i giochi di questa pagina che
        chiudono il conto

   Perche' /cart.js e non uno stato tenuto in pagina: il cliente puo'
   avere gia' roba nel carrello da ieri. Una barra che conta solo i clic
   di oggi avrebbe detto «ti mancano 30 €» a chi ne aveva gia' 40 dentro,
   e avrebbe fatto comprare per sbaglio.
   ============================================================= */
(function () {
  'use strict';

  var root = document.querySelector('[data-asm]');
  var bar = document.querySelector('[data-asm-bar]');
  if (!root) return;

  var FREE = parseInt(root.getAttribute('data-free-ship'), 10) || 0;

  /* Quando proporre di chiudere il conto: solo se manca poco. «Ti mancano
     35 € su 50» non e' un invito, e' un compito — e intanto la barra si
     mangiava 230px su un telefono da 812, cioe' un terzo dello schermo per
     un suggerimento che nessuno avrebbe seguito. Sotto il 40% della soglia
     (20 € su 50) un gioco in piu' e' una decisione vera. */
  var SUGG_WINDOW = Math.round(FREE * 0.4);

  var items = [].slice.call(root.querySelectorAll('[data-asm-item]'));

  function money(cents) {
    return (cents / 100).toLocaleString('it-IT', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: (cents % 100 === 0) ? 0 : 2,
      maximumFractionDigits: 2
    });
  }

  function num(el, attr) { return parseInt(el.getAttribute(attr), 10) || 0; }

  /* ---------- 1. Chip: filtro e ordine ---------- */

  var state = { filter: 'all', sort: 'vetrina' };
  var chipsBox = root.querySelector('[data-asm-chips]');
  var sep = root.querySelector('[data-asm-sep]');
  var noneMsg = root.querySelector('[data-asm-none]');

  function passes(el, f) {
    if (f === 'all') return true;
    if (f === 'p1') return num(el, 'data-band') === 1;
    if (f === 'p2') return num(el, 'data-band') === 2;
    if (f === 'p3') return num(el, 'data-band') === 3;
    if (f === 'fam') return num(el, 'data-fam') === 1;
    if (f === 'due') return num(el, 'data-due') === 1;
    if (f === 'solo') return num(el, 'data-solo') === 1;
    if (f === 'exp') return num(el, 'data-exp') === 1;
    return true;
  }

  /* Gli esauriti prendono 10000 di scarto: qualunque sia l ordinamento
     scelto, finiscono comunque dopo tutti i comprabili e dopo la riga di
     stacco (che sta a 9998 nel CSS). */
  function rank(el, i) {
    return (num(el, 'data-out') === 1 ? 10000 : 0) + i;
  }

  function apply() {
    var shown = 0;
    var outShown = 0;

    items.forEach(function (el) {
      var ok = passes(el, state.filter);
      el.hidden = !ok;
      if (!ok) return;
      if (num(el, 'data-out') === 1) outShown++;
      else shown++;
    });

    /* L'ordine si cambia con `order`, mai spostando i nodi: spostarli
       rompe il focus da tastiera e fa ripartire il lazy-load delle
       immagini gia' scaricate. */
    if (state.sort === 'save') {
      var visible = items.filter(function (el) { return !el.hidden; });
      visible
        .slice()
        .sort(function (a, b) { return num(b, 'data-save') - num(a, 'data-save'); })
        .forEach(function (el, i) { el.style.order = String(rank(el, i)); });
    } else {
      items.forEach(function (el) { el.style.order = String(rank(el, num(el, 'data-idx'))); });
    }

    /* La riga di stacco compare solo se sotto c'e' davvero qualcosa: con un
       filtro attivo puo' non restare nessun esaurito, e una riga «questi sono
       finiti» seguita dal nulla e' peggio che non averla. */
    if (sep) {
      sep.hidden = outShown === 0;
      sep.textContent = outShown === 1
        ? 'Questo è finito'
        : 'Questi sono finiti — ' + outShown;
    }

    if (noneMsg) noneMsg.hidden = (shown + outShown) > 0;
  }

  if (chipsBox) {
    chipsBox.addEventListener('click', function (e) {
      var btn = e.target.closest('.asm-chip');
      if (!btn) return;

      var isSort = btn.hasAttribute('data-sort');
      var group = isSort ? '[data-sort]' : '[data-filter]';

      chipsBox.querySelectorAll(group).forEach(function (b) {
        b.classList.remove('is-on');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-on');
      btn.setAttribute('aria-pressed', 'true');

      if (isSort) state.sort = btn.getAttribute('data-sort');
      else state.filter = btn.getAttribute('data-filter');

      apply();
    });
  }

  apply();

  /* ---------- 2. Il Tavolo ---------- */

  if (!bar || !FREE) return;

  var msgEl = bar.querySelector('[data-asm-msg]');
  var fillEl = bar.querySelector('[data-asm-fill]');
  var savedEl = bar.querySelector('[data-asm-saved]');
  var suggBox = bar.querySelector('[data-asm-fillers]');
  var suggLbl = bar.querySelector('[data-asm-fill-lbl]');
  var suggRow = bar.querySelector('[data-asm-fill-row]');
  var closeBtn = bar.querySelector('[data-asm-close]');

  /* Chiuso a mano = chiuso finche' non cambia qualcosa. Se poi il cliente
     mette un altro gioco nel carrello la barra torna: e' un'informazione
     nuova, non la stessa che aveva gia' scacciato. */
  var dismissedAt = -1;

  /* La barra e' alta in modo diverso a seconda di cosa deve dire (con o
     senza suggerimenti, messaggio su una o due righe). Un valore fisso nel
     CSS lasciava un buco in fondo alla pagina o, peggio, copriva l'ultima
     fila di prodotti. Si misura e basta. */
  function stretto() { return window.innerWidth < 750; }

  function padBody() {
    document.body.style.paddingBottom = bar.hidden ? '' : (bar.offsetHeight + 12) + 'px';
  }

  function byVariant(id) {
    for (var i = 0; i < items.length; i++) {
      if (num(items[i], 'data-vid') === id) return items[i];
    }
    return null;
  }

  function suggestions(remaining, inCart) {
    var free = items.filter(function (el) {
      return num(el, 'data-avail') === 1 && inCart.indexOf(num(el, 'data-vid')) === -1;
    });

    /* Chi chiude il conto sta sopra la soglia che manca: fra questi si
       propone il piu' economico, non il piu' caro. Fare cassa proponendo
       il pezzo grosso e' il modo migliore per non farsi cliccare. */
    var over = free
      .filter(function (el) { return num(el, 'data-price') >= remaining; })
      .sort(function (a, b) { return num(a, 'data-price') - num(b, 'data-price'); });

    if (over.length >= 3) return over.slice(0, 3);

    var under = free
      .filter(function (el) { return num(el, 'data-price') < remaining; })
      .sort(function (a, b) { return num(b, 'data-price') - num(a, 'data-price'); });

    return over.concat(under).slice(0, 3);
  }

  function drawSuggestions(list) {
    suggRow.innerHTML = '';
    list.forEach(function (el) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'asm-sugg';
      b.setAttribute('data-add', el.getAttribute('data-vid'));
      b.innerHTML =
        '<span class="asm-sugg__t"></span><span class="asm-sugg__p"></span>';
      b.querySelector('.asm-sugg__t').textContent = el.getAttribute('data-title');
      b.querySelector('.asm-sugg__p').textContent = money(num(el, 'data-price'));
      suggRow.appendChild(b);
    });
  }

  function refresh() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count || 0;

        if (!count) {
          bar.hidden = true;
          document.body.classList.remove('asm-has-bar');
          padBody();
          dismissedAt = -1;
          return;
        }

        /* Il carrello e' cambiato dopo la chiusura a mano: la barra torna. */
        if (dismissedAt >= 0 && count !== dismissedAt) dismissedAt = -1;
        if (dismissedAt >= 0) return;

        var total = cart.total_price || 0;
        var cartIds = (cart.items || []).map(function (i) { return i.variant_id; });

        /* Il risparmio NON si puo' prendere dal carrello: /cart.js non
           restituisce il compare_at. Si somma dai prodotti di QUESTA pagina
           che sono anche nel carrello — ed e' anche l'unica cosa onesta da
           dire, visto che il resto del carrello non c'entra con lo speciale. */
        var saved = 0;
        (cart.items || []).forEach(function (i) {
          var el = byVariant(i.variant_id);
          if (el) saved += num(el, 'data-save') * (i.quantity || 1);
        });

        var remaining = FREE - total;
        var scatole = count === 1 ? '1 scatola' : count + ' scatole';

        if (remaining <= 0) {
          bar.setAttribute('data-state', 'ok');
          msgEl.textContent = 'Sul tavolo: ' + scatole + ' · ' + money(total) +
            ' · spedizione gratis inclusa';
          fillEl.style.width = '100%';
          suggBox.hidden = true;
        } else {
          bar.setAttribute('data-state', 'near');
          /* Su telefono la frase si ACCORCIA, non si stringe: «Sul tavolo»
             e «per la spedizione gratis» sono cortesia, il numero che manca
             e' l informazione. Stringendo la colonna il testo andava a tre
             righe e la barra si mangiava un terzo di schermo. */
          msgEl.textContent = stretto()
            ? scatole + ' · ' + money(total) + ' · mancano ' + money(remaining) + ' alla spedizione gratis'
            : 'Sul tavolo: ' + scatole + ' · ' + money(total) +
              ' · ti mancano ' + money(remaining) + ' per la spedizione gratis';
          fillEl.style.width = Math.max(4, Math.round((total / FREE) * 100)) + '%';

          var list = remaining <= SUGG_WINDOW ? suggestions(remaining, cartIds) : [];
          if (list.length) {
            suggLbl.textContent = 'Chiudi il conto con';
            drawSuggestions(list);
            suggBox.hidden = false;
          } else {
            suggBox.hidden = true;
          }
        }

        if (saved > 0) {
          savedEl.textContent = 'Risparmi ' + money(saved) + ' su questo speciale';
          savedEl.hidden = false;
        } else {
          savedEl.hidden = true;
        }

        bar.hidden = false;
        document.body.classList.add('asm-has-bar');
        padBody();
      })
      .catch(function () { /* offline: la barra resta com'e' */ });
  }

  /* Il drawer NON si apre: qui il cliente sta ancora scegliendo, e un
     pannello in faccia interrompe. Si aggiorna la barra e basta —
     `cart:refresh` serve al tema per rinfrescare l'icona del carrello. */
  function add(variantId, btn) {
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Aggiungo…';

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart add ' + r.status);
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
        return refresh();
      })
      .catch(function (err) {
        console.error('[Speciale]', err);
        btn.disabled = false;
        btn.textContent = original;
      });
  }

  bar.addEventListener('click', function (e) {
    var b = e.target.closest('[data-add]');
    if (!b) return;
    e.preventDefault();
    add(b.getAttribute('data-add'), b);
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { dismissedAt = c.item_count || 0; })
        .catch(function () { dismissedAt = 0; });
      bar.hidden = true;
      document.body.classList.remove('asm-has-bar');
      padBody();
    });
  }

  window.addEventListener('resize', padBody);

  /* Un solo giro per raffica: il quick add del tema emette piu' eventi di
     fila e senza freno si finirebbe a chiedere /cart.js tre volte. */
  var pending = null;
  function scheduleRefresh() {
    clearTimeout(pending);
    pending = setTimeout(refresh, 180);
  }

  document.addEventListener('cart:updated', scheduleRefresh);
  document.addEventListener('cart:refresh', scheduleRefresh);

  refresh();
})();
